import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import useDebounce from '@/utils/debounce';
import MembersPermissionAddRow from '@/users/membership/components/MembersPermissionAddRow';
import { getMemberId } from '@/users/membership/helper';
import {
  addSearchMembers, updateSearchMemberProperties, fetchSearchMembers, updateShareSearchProperties,
} from '../actions';
import { searchPermissionGroups } from '../constants';

const SearchMemberAddRow = ({
  category,
  code,
  members,
  membersToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addMembers,
  readStatus,
  filter,
  permission,
  allowSecure,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const onFilterChange = useCallback((value) => {
    updateFilter(category, code, value);
    debouncedFetch(category, code, value);
  }, [category, code, updateFilter, debouncedFetch]);

  return (
    <MembersPermissionAddRow
      addMembers={() => addMembers(category, code)}
      allowSecure={allowSecure}
      entity="search"
      filter={filter}
      members={members}
      membersToAdd={membersToAdd}
      onFilterChange={onFilterChange}
      permission={permission}
      permissionGroups={searchPermissionGroups}
      readStatus={readStatus}
      updateProperties={updateProperties}
    />
  );
};

const dialogProps = (sharingSearch, exists, members = []) => (
  {
    exists,
    permission: sharingSearch.permissionGroup,
    membersToAdd: sharingSearch.membersToAdd,
    members: sharingSearch.membersToAdd.concat(members),
  }
);

const withoutItem = (sharingSearch) => (
  {
    ...dialogProps(sharingSearch, false),
    ...readStates,
    filter: '',
  }
);

const withItem = (item, sharingSearch) => {
  const members = item.members.results;
  const assignable = item.unassignedMembers.results;
  const memberIds = members.map(getMemberId);

  return (
    {
      ...dialogProps(sharingSearch, true, assignable.filter((member) => !memberIds.includes(getMemberId(member)))),
      readStatus: item.unassignedMembers.readStatus,
      readErrors: item.unassignedMembers.readErrors,
      filter: item.unassignedMembers.filter,
    }
  );
};

const mapStateToProps = ({
  search: { searches, sharingSearch },
}, { category, code }) => {
  const item = findResult(searches, category, code);
  return item ? withItem(item, sharingSearch) : withoutItem(sharingSearch);
};

const mapDispatchToProps = {
  fetchData: (category, code, filter) => fetchSearchMembers(category, code, true, filter),
  updateFilter: (category, code, filter) => updateSearchMemberProperties(category, code, true, { filter }),
  addMembers: addSearchMembers,
  updateProperties: updateShareSearchProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchMemberAddRow);
